import * as React from 'react';
import { DataTest } from '../../utilities/testAutomation';

export interface ButtonProps extends DataTest {
  name?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  link?: string;
  isDisabled?: boolean;
  analytics?: DataDTM;
  style?: React.CSSProperties;
}

interface DataDTM {
  id: string;
  data: string;
}

const Button = ({
  name,
  onClick,
  link,
  isDisabled,
  analytics,
  dataTest,
  style,
}: ButtonProps) => {
  const buttonMarkup = (
    <button
      style={style}
      className="button hide-print"
      disabled={isDisabled}
      name={name}
      onClick={onClick}
      data-dtm-id={analytics ? analytics.id : ''}
      data-dtm-data={analytics ? analytics.data : ''}
      {...dataTest}
    >
      {name}
    </button>
  );

  return (
    <div className="button-wrapper">
      {link ? (<a href={link} target="_blank" rel="noopener noreferrer">{buttonMarkup}</a>) : buttonMarkup}
    </div>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx